import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { GrupoQuestaoItemModel } from '../models';


@Injectable({
  providedIn: 'root'
})
export class GrupoQuestaoItemService extends BaseCrudService<GrupoQuestaoItemModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'grupoQuestaoItem';
  }

  getByGrupoQuestaoId(id: string): Observable<GrupoQuestaoItemModel[]> {
    return this
      .httpClient
      .get(`${this.getApiUrl()}${this.getController()}/GetByGrupoQuestaoId/${id}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  updateOrdens(ids) {
    return this
      .httpClient
      .post(`${this.getApiUrl()}${this.getController()}/UpdateOrdens`, ids, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
